import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { FormField, Input } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { TextAndStyleDeclineAllButtonMaxLength } from '@src/constants/constants';

const MAX_LEN = TextAndStyleDeclineAllButtonMaxLength;

interface Props extends InjectedTranslateProps {
  value: string;
  onChange: (value: string) => void;
}

const DeclineAllButtonEditorBase = ({ t, value, onChange }: Props) => {
  return (
    <FormField
      label={t('text-and-display.decline-all-button.title')}
      infoContent={t('text-and-display.decline-all-button.tooltip')}
      charCount={MAX_LEN - value.length}
    >
      <Input
        dataHook={DataHooks.TextAndDisplayDeclineAll}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        maxLength={MAX_LEN}
      />
    </FormField>
  );
};

export const DeclineAllButtonEditor = translate()(DeclineAllButtonEditorBase);
